import {
    CkeditorConstants,
  } from "../../src/utils";
  
  const {
    command: {
      ACCEPT_SUGGESTION,
      DISCARD_SUGGESTION,
    },
    KEYWORD_ATTRIBUTE: {
      KEYWORD_TYPE_OF
    },
    class:{WK_KEYWORD_REF},
    helperAttributes: { 
      REMOVE_INSERTEDKEYWORD_DISCARD ,
      REMOVE_KEYWORD_FROM_TRACKCHANGES,
      TYPE_OF,
      RESOURCE
    },
    PLUGINS: { TRACKCHANGE_EDITING },
    htmlAttributes: { CLASS, ID }
  } = CkeditorConstants;
  
  export default class TrackChangesForKeywords {
    constructor(editor) {
      this.editor = editor;
    }
  
    init() {
      const discardSuggestionOn = this.editor.commands.get(DISCARD_SUGGESTION);
      discardSuggestionOn.on(
        "execute",this.onDiscardKeyword.bind(this),{ priority: "highest" }
      );
      
      const acceptSuggestionEvent = this.editor.commands.get(ACCEPT_SUGGESTION);
      acceptSuggestionEvent.on("execute", this.onAcceptKeyword.bind(this), { priority: "highest" }
      )
    }
    /**
     * Callback function on Discard of Keyword Suggestions
     * @param {*} e 
     * @param {suggestion} suggestionData 
     */
    onDiscardKeyword(e, suggestionData) {
      const {
        targetElement,
        suggestion,
        keywordId,
        docRefId,
        markerName
      } = this.getSuggestionData(suggestionData)
      
      if (this.isKeywordSuggestion(targetElement)) {
        let removeKeywordFromTrackChanges = this.shouldRemoveKeywordWithSuggestion(suggestion);
        if(!removeKeywordFromTrackChanges) {
          this.unwrapKeywordAndUpdateStore(markerName, targetElement, keywordId, docRefId);
        }          
      } 
    }

    /**
     * Callback for Accepting the Keyword suggestion
     * @param {*} _event 
     * @param {suggestion} suggestionData 
     */
    onAcceptKeyword(_event, suggestionData) {
      const {
        targetElement,
        suggestion,
        keywordId,
        docRefId,
        markerName
      } = this.getSuggestionData(suggestionData)

      
      if (this.isKeywordSuggestion(targetElement)) {
        let removeKeywordFromTrackChanges = this.shouldRemoveKeywordWithSuggestion(suggestion);
        if (removeKeywordFromTrackChanges && keywordId) {
          this.unwrapKeywordAndUpdateStore(markerName, targetElement, keywordId, docRefId)
        }
      }
    }

    /**
     * This method will retrive the required data from the suggestion
     * @param {*} suggestionData 
     * @returns 
     */
    getSuggestionData(suggestionData){
      const trackChangesEditing = this.editor.plugins.get(TRACKCHANGE_EDITING);
      const suggestionId = suggestionData[0];
      const suggestion = trackChangesEditing.getSuggestion(suggestionId);
      const [markerName] = suggestion.getMarkerNames();
      let [targetElement] = suggestion.getItems();
      targetElement =  targetElement?.textNode && targetElement.parent && this.isKeywordSuggestion(targetElement.parent) ? targetElement.parent : targetElement
      let keywordId, docRefId;
      if(targetElement?._attrs?.get(RESOURCE) && targetElement._attrs.get(ID)){
          keywordId = targetElement._attrs.get(RESOURCE).split('/').pop();
          docRefId = targetElement._attrs.get(ID);
      }
      return {
        'targetElement': targetElement,
        'suggestion': suggestion,
        'keywordId': keywordId,
        'docRefId' : docRefId,
        'markerName': markerName
      }
    }

    /**
     * This method will return boolean to chk if the suggestion is accept/discart for Keyword
     * @param {*} suggestion 
     * @returns 
     */
    shouldRemoveKeywordWithSuggestion(suggestion){
      let removeKeywordFromTrackChanges = false;
      if (
        suggestion.attributes?.commandParams?.hasOwnProperty(
          REMOVE_KEYWORD_FROM_TRACKCHANGES
        )
      ) {
        removeKeywordFromTrackChanges =
          suggestion.attributes.commandParams[REMOVE_KEYWORD_FROM_TRACKCHANGES];
      }
      return removeKeywordFromTrackChanges;
    }

    /**
     * This will unwrap the element and remove the marker from keyword
     * @param {string} markerName 
     * @param {Element} targetElement 
     * @param {Id for Keyword} keywordId 
     * @param {Id for Reference in document} docRefId 
     */
    unwrapKeywordAndUpdateStore(markerName, targetElement, keywordId, docRefId){
      this.editor.model.change((writer) => {
        writer.removeMarker(markerName);
        writer.unwrap(targetElement);
      });
      this.editor.fire(REMOVE_INSERTEDKEYWORD_DISCARD, {'keywordId': keywordId,'docReferenceId': docRefId });
    }
  
    /**
     * This chk for suggestion if its Keyword
     * @param {Element} element 
     * @returns 
     */
    isKeywordSuggestion(element) {
      let isKeywordLink = null;
      if (element) {
        const attributesMap = new Map(element.getAttributes());
        const typeofValue = attributesMap.get(TYPE_OF);
        const classList = attributesMap.get(CLASS);
        isKeywordLink =
        typeofValue === KEYWORD_TYPE_OF &&
          classList?.includes(WK_KEYWORD_REF);
      }
      return isKeywordLink;
    }
  }